import {
  APP_API_ERROR_RESET,
  APP_API_ERROR_SET,
  APP_FIREBASE_REMOTE_CONFIG_FETCH_START,
  APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS,
  APP_SET_PATHNAME,
} from "../constants/app";
import {AppActions, AppState} from "../types/app";

const initialState: AppState = {
  loadingFirebase: true,
  pathname: window.location.pathname,
  apiError: undefined,
}

const reducer = (
  state = initialState,
  action: AppActions,
): AppState => {
  switch (action.type) {
    case APP_FIREBASE_REMOTE_CONFIG_FETCH_START:
      return {
        ...state,
        loadingFirebase: true,
      };
    case APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS:
      return {
        ...state,
        loadingFirebase: false,
      };
    case APP_SET_PATHNAME:
      return {
        ...state,
        pathname: action.payload,
      };
    case APP_API_ERROR_SET:
      return {
        ...state,
        apiError: action.payload,
      };
    case APP_API_ERROR_RESET:
      return {
        ...state,
        apiError: undefined,
      };
    default:
      return state;
  }
}

export default reducer;
